<template>
  <div class="main-setting-menu mmMenuContainer">
    <HeaderMenu
      :title="$t('mareiMekomotSettings.title')"
      :routeBackName="routeBackName"
    />
    <ul class="list-menu">
      <li>{{ $t("mareiMekomotSettings.showMareiMakomRegularlyg") }}:</li>
      <li class="item item-check " :class="{ checked: showMm }">
        <RowItem
          v-disable
          @click="setShow(true)"
          :title="$t('mareiMekomotSettings.on')"
          iconItem="3"
          :HasIconItem="showMm"
          :HasIconArrow="false"
          :HasIconDisplay="false"
        />
      </li>
      <li class="item item-check" :class="{ checked: !showMm }">
        <RowItem
          v-disable
          @click="setShow(false)"
          :title="$t('mareiMekomotSettings.off')"
          iconItem="3"
          :HasIconItem="!showMm"
          :HasIconArrow="false"
          :HasIconDisplay="false"
        />
      </li>

      <!-- <li>
        <RowItem
          v-disable
          @click="setShow(!showMm)"
          :title="$t('mareiMekomotSettings.hideMm')"
          :HasIconItem="false"
          :HasIconArrow="false"
          :HasIconDisplay="false"
          :HasIconCheckbox="true"
          :displayCheckbox="!showMm"
          type="checkbox"
        />
      </li> -->

      <li class="underline-separate"></li>
      <li :class="{ disable: !showMm }">
        {{ $t("mareiMekomotSettings.settingMMActive") }}:
      </li>
      <div class="ltr-dir" :class="{ disable: !showMm }" :disabled="!showMm">
        <li class="switch-small">
          <RowItem
            v-disable
            @click="setShowWithoutTooltip(!MMshowWithoutTooltip)"
            :title="$t('mareiMekomotSettings.showTooltip')"
            :HasIconItem="false"
            :HasIconArrow="false"
            :HasIconDisplay="false"
            :HasIconCheckbox="true"
            :displayCheckbox="!MMshowWithoutTooltip"
            type="checkbox"
          />
        </li>
      </div>
      <li class="underline-separate"></li>
      <li :class="{ disable: showMm }">
        {{ $t("mareiMekomotSettings.settingMM") }}:
      </li>
      <div class="ltr-dir" :class="{ disable: showMm }" :disabled="showMm">
        <li class="switch-small">
          <RowItem
            v-disable
            @click="setHideTextColor(!MMhideMode.color)"
            :title="$t('mareiMekomotSettings.noTextColor')"
            :HasIconItem="false"
            :HasIconArrow="false"
            :HasIconDisplay="false"
            :HasIconCheckbox="true"
            :displayCheckbox="MMhideMode.color"
            type="checkbox"
          />
        </li>
        <li class="switch-small">
          <RowItem
            v-disable
            @click="setHideHover(!MMhideMode.hover)"
            :title="$t('mareiMekomotSettings.noHover')"
            :HasIconItem="false"
            :HasIconArrow="false"
            :HasIconDisplay="false"
            :HasIconCheckbox="true"
            :displayCheckbox="MMhideMode.hover"
            type="checkbox"
          />
        </li>
        <li class="switch-small">
          <RowItem
            v-disable
            @click="setHideTooltip(!MMhideMode.tooltip)"
            :title="$t('mareiMekomotSettings.hideTooltip')"
            :HasIconItem="false"
            :HasIconArrow="false"
            :HasIconDisplay="false"
            :HasIconCheckbox="true"
            :displayCheckbox="MMhideMode.tooltip"
            type="checkbox"
          />
        </li>
        <li class="switch-small">
          <RowItem
            v-disable
            @click="setFullDisable(!MMhideMode.link)"
            :title="$t('mareiMekomotSettings.fullDisable')"
            :HasIconItem="false"
            :HasIconArrow="false"
            :HasIconDisplay="false"
            :HasIconCheckbox="true"
            :displayCheckbox="MMhideMode.link"
            type="checkbox"
          />
          <!-- <div class="dir-rtl flex right-20">
            <baseCheckBox
              :checked="MMhideMode.link"
              @change="setFullDisable(!MMhideMode.link)"
              size="larg"
            />
            <span>{{ $t("mareiMekomotSettings.fullDisable") }}</span>
          </div> -->
        </li>
      </div>
      <li class="underline-separate"></li>
      <li>{{ $t("mareiMekomotSettings.showMM") }}</li>
      <li class="item item-check" :class="{ checked: !MMshowYesodOnly }">
        <RowItem
          @click="setYesodOnly(false)"
          :title="$t('mareiMekomotSettings.allBooks')"
          iconItem="3"
          :HasIconItem="!MMshowYesodOnly"
          :HasIconArrow="false"
          :HasIconDisplay="false"
        />
      </li>
      <li class="item item-check" :class="{ checked: MMshowYesodOnly }">
        <RowItem
          @click="setYesodOnly(true)"
          :title="$t('mareiMekomotSettings.syOnly')"
          iconItem="3"
          :HasIconItem="MMshowYesodOnly"
          :HasIconArrow="false"
          :HasIconDisplay="false"
        />
      </li>
    </ul>
  </div>
</template>

<script>
//compact
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      routeBackName: "settings",
    };
  },
  computed: {
    ...mapGetters("userSetting", [
      "showMm",
      "MMshowWithoutTooltip",
      "MMhideMode",
      "MMshowYesodOnly",
    ]),
  },
  methods: {
    ...mapActions("userSetting", ["setMm"]),
    // setSettingHeightGzir(size) {
    //   this.userSettings.setSettings("height_gzir", size);
    // },
    setShow(val) {
      this.setMm({ key: "show", value: val });
    },
    setShowWithoutTooltip(val) {
      this.setMm({ key: "showWithoutTooltip", value: val });
    },
    setHideTooltip(val) {
      this.setMm({ key: "hideModeHideTooltip", value: val });
    },
    setHideHover(val) {
      this.setMm({ key: "hideModeHideHover", value: val });
    },
    setHideTextColor(val) {
      this.setMm({ key: "hideModeHideTextColor", value: val });
    },
    setFullDisable(val) {
      this.setMm({ key: "fullDisable", value: val });
    },
    setYesodOnly(val) {
      this.setMm({ key: "yesodOnly", value: val });
    },
  },
};
</script>

<style lang="scss">
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 4;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-display-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
  overflow: auto;
  flex-grow: 1;
}
.underline-separate {
  border-bottom: 1px solid #ececec;
  margin-top: 13px;
  margin-bottom: 16px;
}
.footer-menu {
  background-color: #f4f4f4;
  height: 60px;
  border: 1px solid #dedede;
}
.switch-small {
  line-height: 25px;
}
.ltr-dir {
  direction: ltr;
}
</style>
